<template>
    <div v-cloak class="configuration-wrapper">
        <toggle-switch
            v-bind:are-you-sure="{
                value: true,
                text: 'These settings will be applied for the centre. Are you sure you want to continue?'
            }"
            v-on:input="updateVueModelForSwitcher($event)" v-bind:id="configurationKey+centreId"
            v-bind:name="configurationKey+'-switch'"
            v-bind:value="currentValue"></toggle-switch>
    </div>
</template>

<script>
    import Configurations from "../Services/Configurations";

    export default {
        name: "CentreToggleSwitch",
        props: {
            isAllowedToEdit: Boolean,
            centreId: Number,
            initialValue: Boolean,
            configurationKey: String
        },
        data: function()  {
            return {
                currentValue: false,
            }
        },
        mounted() {
            this.currentValue = this.initialValue;
        },
        methods: {
            setCentreConfiguration: function() {
                if (this.configurationKey === "remoteAccess") {
                    this.toggleRemoteAccessConfiguration();
                }
            },
            toggleRemoteAccessConfiguration: function() {
                Configurations.toggleRemoteAccess(this.centreId).then((resultValue) => {
                    this.currentValue = resultValue;
                }).catch((error) => {
                    console.log(error.response);
                })
            },

            updateVueModelForSwitcher: function($event) {
                this.currentValue = $event;
                this.setCentreConfiguration();
                this.$forceUpdate();
            },

        }
    }
</script>

